import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Plus } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FavoriteUser } from '@/hooks/use-favorite-users';
import DraggableUserList from './DraggableUserList';
import AddUserSelector from './AddUserSelector';

interface EditFavoritesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  favorites: FavoriteUser[];
}

const EditFavoritesModal = ({ open, onOpenChange, favorites }: EditFavoritesModalProps) => {
  const [activeTab, setActiveTab] = useState('manage');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-hidden">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span>Edit My Top Follows</span>
            <span className="text-sm text-muted-foreground">
              ({favorites.length}/20)
            </span>
          </DialogTitle>
        </DialogHeader>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="manage">Manage Order</TabsTrigger>
            <TabsTrigger value="add" className="flex items-center gap-2">
              <Plus className="w-4 h-4" />
              Add Users
            </TabsTrigger>
          </TabsList>

          <TabsContent value="manage" className="mt-4">
            <div className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Drag and drop to reorder your favorite users
              </p>
              <DraggableUserList favorites={favorites} />
            </div>
          </TabsContent>

          <TabsContent value="add" className="mt-4">
            <div className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Add users you follow to your top follows list
              </p>
              <AddUserSelector 
                favorites={favorites} 
                onUserAdded={() => setActiveTab('manage')}
              />
            </div>
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default EditFavoritesModal;